import { render, staticRenderFns } from "./InputFieldCpt.vue?vue&type=template&id=3fb97fbb&scoped=true&"
import script from "./InputFieldCpt.vue?vue&type=script&lang=ts&"
export * from "./InputFieldCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb97fbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
